import {FlagOutlined as FlagIcon} from '@mui/icons-material';
import { colors } from '@mui/material';
export function getDifferenceFlagProps(
  clearanceFlag: string
): { icon: typeof FlagIcon; color: string; tooltip: string } | null {
  switch (clearanceFlag) {
    case 'CONTENT_MISSING':
      return {
        icon: FlagIcon,
        color: colors.red[600], // strong red
        tooltip:
          'This DTB contains references to policy manual content that cannot be found in your policy manual. Please edit this DTB to remove those references. By Clearing this flag, you are accepting responsibility for the correctness of this DTB.',
      };
    case 'CONTENT_DIFFERENCES':
      return {
        icon: FlagIcon,
        color: colors.amber[700], // amber/yellow
        tooltip:
          'This DTB contains references to policy manual content that has been modified from the Lexipol Master Content. Please ensure that the links are still relevant and make sense for the DTB. By clearing this flag, you are accepting responsibility for the correctness of this DTB.',
      };
    case 'PENDING_UPDATES':
      return {
        icon: FlagIcon,
        color: colors.blueGrey[700], // blue-grey
        tooltip: 'This DTB has manual references with updates pending in draft.',
      };
    default:
      return null;
  }
}
